var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Navbar',{attrs:{"user":_vm.user,"device":_vm.device},on:{"logout":_vm.logout}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }